module.exports = __webpack_public_path__ + "static/media/mobiledemo3.56fb01c6.jpg";